import { createTheme } from "@mui/material";


const customTheme = createTheme()

const theme = createTheme(customTheme, {
    palette: {
        primary: {
            light: "#FFC27A",
            main: "#FCB364",
            dark: "#FFA539",
        },
    },
    placeholder: {
        color: "#aaa"
    },

    typography: {
        fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
        h6: {
            "fontWeight": "normal",
        },
    },
    components: {
        MuiAppBar: {
            styleOverrides: {
                root: {
                    boxShadow: 'none',
                    backgroundColor: 'white'
                }
            }
        },
        MuiToolbar: {
            styleOverrides: {
                root: {
                }
            }
        },
        MuiAvatar: {
            styleOverrides: {
                root: {
                    width: '100%',
                    height: '100%',
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    boxShadow: 'none',
                    borderRadius: '10px'
                }
            }
        }
    },
    overrides: {
        MuiFilledInput: {
            underline: {
                borderRadius: 10,
                borderBottom: "none",

                "&:hover": {
                    "&:before": {
                        borderBottom: "none"
                    },
                },

                "&:before": {
                    borderBottom: "none"
                },

                "&:after": {
                    borderBottom: "none"
                },
            },
        },
        MuiAvatar: {
            root: {
                height: 200,
                width: 200,
                margin: "0 40 0 0"
            }
        },
        MuiGrid: {
            root: {
                marginTop: 0,
            }
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    boxShadow: 'none'
                },
            },
            elevation1: {
                boxShadow: "none",
                padding: "20"
            }
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    boxShadow: 'none'
                },
            },
        },
        MuiTooltip: {
            tooltip: {
                fontSize: "2em",
                color: "yellow",
                backgroundColor: "red"
            }
        }
    },
})


export default theme;
